import { useMutation } from '@tanstack/react-query';

import { analyzeEmail } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useAnalyzeEmail() {
  const analyzeEmailRequest = async ({
    emailId,
    partyId,
  }: {
    emailId: string;
    partyId: string;
  }) => {
    const result = await analyzeEmail(
      {
        body: {
          party_id: partyId,
        },
        params: {
          path: {
            email_id: emailId,
          },
        },
      },
      wgApi,
    );

    return {
      emailId: result.email_id,
      entitiesJobId: result.entities_job_id ?? null,
    };
  };

  return useMutation({
    mutationFn: analyzeEmailRequest,
  });
}
